import PropTypes from 'prop-types'
import { useState, useEffect, useRef } from 'react'
import { Modal } from 'react-bootstrap'
import Slider from 'react-slick'

import sinfoto from '../../../../src/img/sinfoto.jpg'
import youtubeIcon from '../../../../src/img/youtube-icon.svg'
import { sanitizeImageUrl, sanitizeYoutubeUrl } from '../../../helpers/sanitizeUrl.js'
import { useImagenesPublicacion } from '../../../hooks/useImagenesPublicacion.js'
import CarouselBig from '../carouselBig/CarouselBig'
import styles from './Carousel.module.css'
import './slick/slick.css'
import './slick/slick-theme.css'

const Carousel = ({ detalle }) => {
  const refSlider = useRef()
  const [show, setShow] = useState(false)
  const { adjuntos, loadingImagenes, fetchImagenes } = useImagenesPublicacion()

  useEffect(() => {
    if (detalle?.idPublicacion) {
      fetchImagenes({
        idPublicaciones: [detalle.idPublicacion],
        soloImagenPrincipal: false
      })
    }
  }, [detalle?.idPublicacion])

  const youtubeWatchUrl = sanitizeYoutubeUrl(detalle?.youtube)

  const settings = {
    dots: true,
    infinite: adjuntos.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  }

  return (
    <>
      {loadingImagenes ? (
        <div className="mx-auto spinner-border text-secondary">
          <span className="sr-only"></span>
        </div>
      ) : (
        <Slider {...settings} ref={refSlider}>
          {adjuntos.map((adjunto) => (
            <div key={adjunto.idAdjunto} className="slide-container">
              <img
                src={sanitizeImageUrl(adjunto.url, sinfoto)}
                alt={adjunto.nombre}
                className={styles.zoomInButton}
                onClick={() => setShow(true)}
              />
            </div>
          ))}
          {youtubeWatchUrl && (
            <div className={styles.youtubeSlide}>
              <a
                href={youtubeWatchUrl}
                target="_blank"
                rel="noopener noreferrer"
                title="Ver video en YouTube"
                className={styles.youtubeContainer}
              >
                <span className={styles.youtubeText}>Ver en YouTube</span>
                <img src={youtubeIcon} alt="" aria-hidden="true" className={styles.youtubeIcon} />
              </a>
            </div>
          )}
        </Slider>
      )}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        id="modalCarousel"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CarouselBig idPublicacion={detalle?.idPublicacion} adjuntos={adjuntos} />
        </Modal.Body>
      </Modal>
    </>
  )
}

Carousel.propTypes = {
  detalle: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired,
    youtube: PropTypes.string
  }).isRequired
}
export default Carousel
